<template>
  <div id="header">
    <router-link to="/"><img src="../assets/owal-logo.png" id='logo' alt='logo' /></router-link>
    <div class="main-header-area">
    <div id="header-text"><router-link to="/">Owal Faces</router-link></div>
    <div class="separator" v-if="isLoggedIn">|</div>
    <router-link to="/faces" v-if="isLoggedIn">Faces List</router-link>
    <div class="separator" v-if="isLoggedIn">|</div>
    <router-link to="/detected" v-if="isLoggedIn">Faces Detected</router-link>
    <div class="separator" v-if="isLoggedIn">|</div>
    <router-link to="/more" v-if="isLoggedIn">More</router-link>
    </div>
    <div class="header-login">
      <div v-if="!isLoggedIn">
        Please <router-link to="/login">Log in</router-link>
      </div>
      <div v-if="isLoggedIn">
        Welcome, {{displayName}}! <a v-on:click="logout()">Logout</a>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters} from 'vuex';

export default {
  name: 'header',
  // computed: {
  //   ...mapGetters(['isLoggedIn', 'displayName'])
  //   // isLoggedIn() {
  //   //   return this.$store.getters.isLoggedIn;
  //   // }
  // }
  computed: mapGetters(['isLoggedIn', 'displayName']),
  methods: {
    logout() {
      this.$store.commit('logout');
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>
#header {
  background-color: #181818;
  padding: 20px 20px 20px 20px;
  /* height: 100px; */
  color: white;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

#logo {
  animation: logo-spin infinite 20s linear;
  height: 80px;
  margin-right: 20px;
}

@keyframes logo-spin {
  from {transform: rotate(0deg); }
  to {transform: rotate(360deg);}
}

.main-header-area {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.header-login {
  margin-left: auto;
  padding-right: 40px;
}

.separator {
  font-size: x-large;
  color: white;
  margin: 0px 10px 0px 10px;
}

.main-header-area a {
  font-size: x-large;
  color: white;
  text-decoration: none;
}

.header-login a {
  color: white;
  text-decoration: none;
}

.header-login a:hover {
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// Header.vue?3e8bee59